import { Component, OnInit, OnDestroy } from "@angular/core";
import { Store } from "@ngrx/store";
import { AppState } from "@store/app-state";
import { RequestOptions } from "@angular/http";
import { Angular2TokenService } from "angular2-token";
import { Actions } from "@ngrx/effects";
import { Subscription } from "rxjs/Subscription";
import { EventsStore } from "@store/events";
import { ContactsStore } from "@store/contacts";
import { Event } from "@models/event";
import { Contact } from "@models/contact";
import {
  PURCHASE_TICKET_AS_STAFF,
  PURCHASED_TICKET_AS_STAFF,
  PURCHASE_TICKET_AS_STAFF_FAILURE,
  CLEAR_EVENT_ERRORS
} from "@reducers/events";
import {
  FETCH_STUDENTS,
  FETCH_CONTACTS
} from "@reducers/contacts";
import { ContactSearchParams } from "@services/contact";
import { ConstantsHelpers } from "@constants/helpers";
import { CompleterData, CompleterService, CompleterItem, RemoteData } from "ng2-completer";
import { Ticket } from "@models/ticket";
import { EventPurchaseAsExistingParams } from "@reducers/effects/event";
import { TicketAllocation } from "@models/ticket-allocation";
import { ModalService } from "@services/modal";

@Component({
  selector: 'ticket-form',
  templateUrl: './ticket-form.pug',
})
export class TicketFormComponent implements OnInit, OnDestroy {

  private readonly contactsUrl: string = "api/v1/contacts?contact_type=0&has_debtor_with_cc=true&name="

  private eventsSubscription: Subscription

  public studentsSearchStr: string
  public studentsCompleter: RemoteData

  public params: EventPurchaseAsExistingParams
  public event: Event
  public students: Contact[] = []
  public totalPrice: number = 0
  public errors: any
  public loading: boolean = false

  constructor(
    private store: Store<AppState>,
    private completerService: CompleterService,
    private actions: Actions,
    private http: Angular2TokenService,
    private modalService: ModalService
  ) {}

  ngOnInit() {
    this.eventsSubscription = this.store.select("eventsReducer")
      .subscribe((s: EventsStore) => {
        this.event = s.activeEvent
        this.errors = s.errors
        this.loading = s.loading
      })

    this.studentsCompleter =
      this.completerService.remote(this.contactsUrl, "email", "email")

    this.studentsCompleter.requestOptions(
      new RequestOptions({
        headers: this.http.currentAuthHeaders,
      })
    )
    this.params = {
      ticket_allocation_ids: [],
      student_id: null,
      skip_payment: false,
    }
  }

  fetchPotentialStudents() {
    const payload: ContactSearchParams = {
      contact_type: 0,
      has_debtor_with_cc: true,
    }
    this.store.dispatch({ type: FETCH_CONTACTS, payload })
  }

  selectedStudent(e: CompleterItem) {
    if (e && e.originalObject) {
      const student = Contact.clone(e.originalObject)
      this.params.student_id = student.id
    }
    else {
      this.params.student_id = null
    }
  }

  isTicketAllocationSelected(ta: TicketAllocation): boolean {
    return this.params.ticket_allocation_ids.includes(ta.id)
  }

  clickedTicketAllocation(ta: TicketAllocation) {
    const isPresent = this.params.ticket_allocation_ids.includes(ta.id)

    if (isPresent) {
      this.params.ticket_allocation_ids =
        this.params.ticket_allocation_ids.filter(n => n != ta.id)
    } else {
      this.params.ticket_allocation_ids.push(ta.id)
    }

    this.setPrice()
  }

  setPrice() {
    const tas = this.event.ticketAllocations.filter(
      (ta) => this.params.ticket_allocation_ids.includes(ta.id))

    this.totalPrice = tas.map(ta => ta.price).reduce((n, p) => n + p, 0)
  }

  isFormValid(): boolean {
    return this.params.student_id && (this.params.ticket_allocation_ids.length > 0)
  }

  clickedPurchase() {
    this.actions
      .ofType(PURCHASED_TICKET_AS_STAFF)
      .take(1)
      .subscribe((a) => {
        this.store.dispatch({ type: CLEAR_EVENT_ERRORS })

        switch(a.type) {
          case PURCHASED_TICKET_AS_STAFF: {
            this.modalService.closeModal()
            break
          }
          case PURCHASE_TICKET_AS_STAFF_FAILURE: {
            break
          }
        }
      })

    this.store.dispatch({ type: PURCHASE_TICKET_AS_STAFF, payload: this.params })
  }

  getKeys(errors: any): string[] { return Object.keys(errors) }

  ngOnDestroy() {
    this.eventsSubscription.unsubscribe()
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/components/ticket-form.ts